'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = nonconfigurable;

var _privateUtils = require('./private/utils');

function handleDescriptor(target, key, descriptor) {
  descriptor.configurable = false;
  return descriptor;
}

function nonconfigurable() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0, _privateUtils.decorate)(handleDescriptor, args);
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/core-decorators/lib/nonconfigurable.js
// module id = 26
// module chunks = 0